import { useEffect, useState } from 'react';

export interface BufferingState {
  /** Kısa takılmalarda gösterilmez; `delayMs` sonrası görünür. */
  visible: boolean;
  /** Uzun beklemede kalite düşürme önerisi gösterilir. */
  slow: boolean;
}

/**
 * Oynatıcı bekleme göstergesi.
 *
 * `waiting` olayı her tampon doldurmada tetiklenir; hemen spinner göstermek
 * arayüzü titretir. Bu yüzden kısa bir gecikme vardır. Uzun beklemede
 * "Bağlantı yavaş" ve kalite düşürme seçeneği gösterilir.
 */
export function useBufferingState(
  waiting: boolean,
  { delayMs = 700, slowMs = 8000 }: { delayMs?: number; slowMs?: number } = {},
): BufferingState {
  const [visible, setVisible] = useState(false);
  const [slow, setSlow] = useState(false);

  useEffect(() => {
    if (!waiting) {
      setVisible(false);
      setSlow(false);
      return;
    }

    const showTimer = window.setTimeout(() => setVisible(true), delayMs);
    const slowTimer = window.setTimeout(() => setSlow(true), slowMs);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(slowTimer);
    };
  }, [waiting, delayMs, slowMs]);

  return { visible, slow };
}
